import { apiClient } from 'services/api-client';
import { HelpDeskTicket, HelpDeskTicketDetail } from './type';
import { getLocale, getProfileId } from 'lib/store';

export const getAllHelpDesk = async () => {
  return (await apiClient.get('/helpdesk_management', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
    },
  })) as HelpDeskTicket[];
};

export const getHelpDeskDetail = async (ticket_id: string) => {
  return (await apiClient.get('/helpdesk_management', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
      ticket_id,
    },
  })) as HelpDeskTicketDetail;
};

export const addNewTicket = async (data: FormData) => {
  return await apiClient.post(
    `/helpdesk_management?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  );
};

export const deleteTicket = async (payload: string[]) => {
  return await apiClient.delete(
    `/helpdesk_management?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    {
      data: { ticket_id: payload },
    }
  );
};

export const createTicketComment = async (
  params: { event_type?: string; ticket_id: string },
  payload: FormData
) => {
  return await apiClient.post(
    `/helpdesk_management?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    payload,
    { params }
  );
};
